// 资源位跳转类型
export enum JUMP_TYPE {
  LINK = 0, // 资源位(H5页面)
  PGC = 1, // PGC文章
  UGC_DPT = 2, // UGC点评帖
  SPECIAL = 3, // 内容专题
  UGC_DTT = 4, // UGC动态帖
  TOPIC = 5, // 话题详情页
  SPACE = 6, // 个人空间
  GOODS = 18, // 商品详情
  SHOP_H5 = 27, // 电商H5
  STORE = 31, // 门店
  MATERIAL = 39, // 素材分类
  PERSONAL_DATA = 49, // 编辑个人资料
  PUBLISH_PAGE1 = 50, //  点评贴
  PUBLISH_PAGE2 = 51, // 动态帖
  CR = 54, // cr客服
  HOME = 100, // 首页
  CAR = 21, // 爱车tab
  HOME_CHARGING = 48, // 家充桩首页
  HOME_MAP = 42, // 充电地图首页
}

// 需要将传进来的路径转码
export const needEncodeURIComponent = 'url'

// [资源位code]: { wxUrl: "这里是微信路由",appScheme: "这里是和app约定好的scheme", encodeURIComponentUrl: "这里是需要转码的链接，不配就是不需要转", appNeedEncode: "boolean， 默认true, 这个表示在encodeURIComponentUrl字段存在的情况下，app内不看encodeURIComponentUrl字段"}
// 资源位跳转配置信息
export const JUMP_INFO = {
  [JUMP_TYPE.LINK]: { wxUrl: '/pages/entry/index?url=', appScheme: 'avatar://jsbjumpweb?url=', encodeURIComponentUrl: needEncodeURIComponent },
  [JUMP_TYPE.PGC]: { wxUrl: '/pages/entry/index?url=', appScheme: 'avatar://jsbpgcdetail?pgcId=', encodeURIComponentUrl: `${process.env.REACT_APP_PLANET_DOMAIN}/article/`, appNeedEncode: false },
  [JUMP_TYPE.UGC_DPT]: { wxUrl: '/packages/community/pages/ugc/index?id=', appScheme: 'avatar://jsbugcremarkdetail?ugcId=', },
  [JUMP_TYPE.SPECIAL]: { wxUrl: '/packages/community/pages/special/detail/index?id=', appScheme: 'avatar://jsbspecialtopic?specialId=', },
  [JUMP_TYPE.UGC_DTT]: { wxUrl: '/packages/community/pages/ugc/index?id=', appScheme: 'avatar://jsugcdynamicsdetail?ugcId=', },
  [JUMP_TYPE.TOPIC]: { wxUrl: '/packages/community/pages/topic/index?id=', appScheme: 'avatar://jsbtopic?topicId=', },
  [JUMP_TYPE.SPACE]: { wxUrl: '/pages/user/index?id=', appScheme: 'avatar://jsbuserspace?userId=', },
  [JUMP_TYPE.GOODS]: { wxUrl: '/packages/shop/pages/webview/index?url=', appScheme: 'avatar://jsbgoods?goodsId=', encodeURIComponentUrl: `${process.env.REACT_APP_SHOP_DOMAIN}/product/detail?productId=`, appNeedEncode: false },
  [JUMP_TYPE.SHOP_H5]: { wxUrl: '/packages/shop/pages/webview/index?url=', appScheme: 'avatar://jsbjumpweb?url=', encodeURIComponentUrl:  needEncodeURIComponent},
  [JUMP_TYPE.STORE]: { wxUrl: '/pages/entry/index?url=', appScheme: 'avatar://jsbjumpweb?url=', encodeURIComponentUrl: needEncodeURIComponent },
  [JUMP_TYPE.MATERIAL]: { wxUrl: '/pages/entry/index?url=', appScheme: 'avatar://jsbjumpweb?url=', encodeURIComponentUrl: `${process.env.REACT_APP_PLANET_DOMAIN}/material?id=` },
  [JUMP_TYPE.PERSONAL_DATA]: { wxUrl: '', appScheme: 'avatar://editUserInfo' },
  [JUMP_TYPE.PUBLISH_PAGE1]: { fnName: "publicPost", fnParams: { contentType: 1 } },
  [JUMP_TYPE.PUBLISH_PAGE2]: { fnName: "publicPost", fnParams: { contentType: 2 } },
  [JUMP_TYPE.HOME]: { wxUrl: '/pages/home/index', appScheme: 'avatar://jsbhome' },
  [JUMP_TYPE.CAR]: { fnName: "switchToCarTab" },
  [JUMP_TYPE.CR]: { fnName: "wxCustomer" },
  [JUMP_TYPE.HOME_CHARGING]: { wxUrl: '', appScheme: 'avatar://jsbjumpweb?url=', encodeURIComponentUrl: `${window.location.origin}/homeCharging/index`},
  [JUMP_TYPE.HOME_MAP]: { wxUrl: '', appScheme: 'avatr://charging_home' },
}

// 权益状态
export enum ACCOUNT_STATUS {
  EFFECTIVE = 1, // 有效
  SEND_BACK = 2, // 退回
  PAST_DUE = 3, // 已过期
  USED = 4, // 已核销、已使用
  FREEZE = 5, // 冻结
  TO_ACTIVATE = 6, // 待激活
  UNFREEZE = 7, // 解冻
  ON_COOL = 8, // 冷却中
  MOVED = 9, // 已转移
  ACTIVING = 16, // 激活中
}

export enum ISSUE_CONTENT_TYPE {
  DYNAMIC = 3,
  COMMENT= 2,
}